import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';

const DirectValuesProposalSection = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <div className='flex flex-col gap-[4px]'>
      <Heading.H6 className='text-text-brand-secondary' fontWeight={FontWeight.SEMIBOLD}>
        {title}
      </Heading.H6>
      <Text.H9 className='text-text-main-primary-inverse' fontWeight={FontWeight.REGULAR}>
        {description}
      </Text.H9>
    </div>
  );
};
export const DirectValuesProposal = () => {
  const sections = [
    {
      title: 'Banking',
      description:
        'Savings account with 3.0% APY¹, Lili Visa® Debit Card, no hidden fees, no overdraft fees, and no deposit or minimum balance required.',
    },
    {
      title: 'Accounting',
      description:
        'Smart bookkeeping, instant transaction categorization, automated reports & insights, bill management and invoicing software².',
    },
    {
      title: 'Tax preparation',
      description:
        'Automatic tax savings, write-off tracker, expense reports and pre-filled tax forms².',
    },
  ];
  const disclaimers = [
    'Lili is a financial technology company, not a bank. Banking services provided by Sunrise Banks, N.A., Member FDIC',
    '¹The Annual Percentage Yield (“APY”) for the Lili Savings Account is variable and may change at any time.',
    'The disclosed APY is effective as of January 1, 2025. Must have at least $0.01 in savings to earn interest. The APY applies to balances of up to and including $100,000. Any portions of a balance over $100,000 will not earn interest or have a yield. Available to Lili Pro, Lili Smart, and Lili Premium account holders only.',
    '²Available to Lili Smart and Lili Premium account holders only, applicable monthly account fee applies. Please refer to our Terms and Conditions for details.',
  ];
  return (
    <div className='flex flex-col w-full gap-[24px] tab-landscape:pb-[20px] no-scrollbar overflow-scroll h-full'>
      <Heading.H9
        fontWeight={FontWeight.SEMIBOLD}
        className='max-w-[477px] text-text-main-primary-inverse w-full'>
        Bank smarter with the business checking account that any business needs
      </Heading.H9>

      {sections.map(({ title, description }) => (
        <DirectValuesProposalSection title={title} description={description} />
      ))}

      <div className='flex flex-col gap-[16px] pt-[16px] pb-[80px] border-t border-outline-primary-bw-05 w-full  mt-[96px]'>
        <div className='flex flex-col w-full'>
          {disclaimers.map((disclaimer) => (
            <Text.H14 fontWeight={FontWeight.REGULAR} className='text-text-main-primary-inverse'>
              {disclaimer}
            </Text.H14>
          ))}
        </div>
        <div className='flex flex-col gap-[4px] tab-landscape:bg-transparent'>
          <Text.H13 fontWeight={FontWeight.MEDIUM} className='text-text-main-primary-inverse'>
            USA PATRIOT Act notice
          </Text.H13>
          <Text.H14 fontWeight={FontWeight.REGULAR} className='text-text-main-primary-inverse'>
            To help the government fight the funding of terrorism and money laundering activities,
            Federal law requires all financial institutions to obtain, verify, and record
            information that identifies each person who opens an account. What this means for you:
            When you open an account, we will ask for your name, address, date of birth, and other
            information that will allow us to identify you. We may also ask to see your driver's
            license or other identifying documents.
          </Text.H14>
        </div>
      </div>
    </div>
  );
};
